/* Add-on product card ("Complete your order") - snippets/product-addon.liquid */
if (!customElements.get('product-addon')) {
  class ProductAddon extends HTMLElement {
    connectedCallback() {
      if (this.isReady) return;
      this.isReady = true;

      this.button = this.querySelector('[data-addon-add]');
      this.qtyInput = this.querySelector('[data-addon-qty]');
      this.variantSelect = this.querySelector('[data-addon-variant]');
      this.priceEl = this.querySelector('[data-addon-price]');
      this.msgEl = this.querySelector('[data-addon-msg]');
      if (!this.button) return;

      this.button.addEventListener('click', () => this.addToCart());

      this.qtyMinus = this.querySelector('[data-addon-qty-minus]');
      this.qtyPlus = this.querySelector('[data-addon-qty-plus]');
      this.qtyMinus.addEventListener('click', () => this.setQuantity(this.getQuantity() - 1));
      this.qtyPlus.addEventListener('click', () => this.setQuantity(this.getQuantity() + 1));
      this.qtyInput.addEventListener('change', () => this.setQuantity(this.getQuantity()));

      // The card sits inside the main product form: Enter in the quantity box
      // would submit that form and add the main product instead.
      this.qtyInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.addToCart();
      });

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', () => {
          const option = this.variantSelect.selectedOptions[0];
          if (option && option.dataset.price) this.priceEl.innerHTML = option.dataset.price;
        });
      }

      this.initShowWhen();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    // Optional block setting: only show the card while a main product option
    // value (e.g. "Velcro") is selected. Reads the theme's swatch labels.
    initShowWhen() {
      this.showWhen = (this.dataset.showWhen || '').trim().toLowerCase();
      if (!this.showWhen) return;

      const form = this.closest('form');
      this.swatch = form && form.querySelector('.t4s-swatch');
      if (!this.swatch) return;

      this.observer = new MutationObserver(() => this.toggleByOption());
      this.observer.observe(this.swatch, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      this.toggleByOption();
    }

    toggleByOption() {
      const values = Array.from(this.swatch.querySelectorAll('.t4s-swatch__current'), (el) => el.textContent.trim().toLowerCase());
      this.hidden = !values.includes(this.showWhen);
    }

    async addToCart() {
      if (this.button.disabled) return;

      const id = Number(this.variantSelect ? this.variantSelect.value : this.dataset.variantDefault);
      const quantity = this.getQuantity();
      this.setQuantity(quantity);

      this.setMessage('');
      this.setState('is--loading');

      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        const data = await response.json();

        if (!response.ok) {
          this.setState('');
          this.setMessage(data.description || data.message);
          return;
        }

        this.setQuantity(1);
        this.setState('is--added');
        this.stateTimer = setTimeout(() => this.setState(''), 2000);
        this.refreshCart();
      } catch (error) {
        console.error(error);
        this.setState('');
        this.setMessage(this.dataset.errorText);
      }
    }

    // Same path as the theme's own Add to cart: re-render the mini cart, then run
    // the "Action when an item is added to the cart" theme setting (drawer by default).
    refreshCart() {
      if (window.T4SThemeSP && window.T4SThemeSP.Cart) {
        document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
      } else {
        window.location.href = this.dataset.cartUrl;
      }
    }

    getQuantity() {
      return Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
    }

    setQuantity(quantity) {
      const value = Math.max(1, quantity);
      this.qtyInput.value = value;
      this.qtyMinus.disabled = value <= 1;
    }

    setState(state) {
      clearTimeout(this.stateTimer);
      this.button.classList.remove('is--loading', 'is--added');
      if (state) this.button.classList.add(state);
      this.button.disabled = state === 'is--loading';
      this.button.setAttribute('aria-busy', state === 'is--loading');
    }

    setMessage(text) {
      this.msgEl.textContent = text || '';
      this.msgEl.hidden = !text;
    }
  }

  customElements.define('product-addon', ProductAddon);
}
